// extracted by mini-css-extract-plugin
export default {"container":"F0-z","list":"G0-z"};